<!-- textBeforeTitle -->
<template>
  <div class="textBeforeTitle">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="文前内容标题：" prop="textBeforeTitle">
        <el-input v-model="ruleForm.textBeforeTitle" type="text" class="fl" style="width: 50%;" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'textBeforeTitle',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
